exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.placeholder[data-v-692e803d] {\n  -webkit-filter: blur(15px);\n          filter: blur(15px);\n  top: 0;\n  left: 0;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n.full-size[data-v-692e803d] {\n  top: 0;\n  left: 0;\n  position: absolute;\n}\n.outer-container[data-v-692e803d] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: block;\n}\n", ""]);

// exports
